/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ExemptionMeta model module.
 * @module model/ExemptionMeta
 * @version 1.0.0
 */
class ExemptionMeta {
    /**
     * Constructs a new <code>ExemptionMeta</code>.
     * @alias module:model/ExemptionMeta
     */
    constructor() { 
        
        ExemptionMeta.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ExemptionMeta</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ExemptionMeta} obj Optional instance to populate.
     * @return {module:model/ExemptionMeta} The populated <code>ExemptionMeta</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ExemptionMeta();

            if (data.hasOwnProperty('check')) {
                obj['check'] = ApiClient.convertToType(data['check'], 'Boolean');
            }
            if (data.hasOwnProperty('percent')) {
                obj['percent'] = ApiClient.convertToType(data['percent'], 'Number');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Indica si se aplica una exención
 * @member {Boolean} check
 */
ExemptionMeta.prototype['check'] = undefined;

/**
 * Porcentaje de exención
 * @member {Number} percent
 */
ExemptionMeta.prototype['percent'] = undefined;

/**
 * Tipo de exención (freelance, etc.)
 * @member {String} type
 */
ExemptionMeta.prototype['type'] = undefined;






export default ExemptionMeta;

